import {
  Button,
  Heading,
  HStack,
  Image,
  List,
  ListItem,
  Stack,
  Text,
} from '@chakra-ui/react';
import { FC } from 'react';
import { useAppContext } from '@frx/frx-react-context';
import { useNavigate } from 'react-router-dom';
import { StepRuler } from './StepRuler';
import { useMobileCheckDepositContext } from '../../context';
import { CheckShield } from '../../../../assets';
import { useEventId } from '../../../../hooks';

export const sanitizeImageData = (str = '') =>
  str.replace('data:image/jpeg;base64,', '');

export const Review: FC = () => {
  const {
    data: {
      authData: { user },
    },
  } = useAppContext();
  const {
    data: {
      formData,
      steps: { activeStep, prevSteps },
    },
    commands: { handleStep, sendDonations },
  } = useMobileCheckDepositContext();

  const eventId = useEventId();
  const navigate = useNavigate();

  const step = 4;
  const isActive = activeStep === 4;

  const hasStep = prevSteps.includes(step);
  const handleReview = () => {
    if (hasStep) {
      handleStep(step);
    }
  };

  const handleSendDonations = () =>
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    sendDonations.mutate(
      {
        giftAmount: Number(formData?.giftAmount),
        backImage: sanitizeImageData(formData?.checkBackImage?.imageData),
        frontImage: sanitizeImageData(formData?.checkFrontImage?.imageData),
        eventId,
        participantConsId: Number(user?.cons_id),
        donorFirstName: formData?.donorFirstName,
        donorLastName: formData?.donorLastName,
      },
      {
        onSuccess: () => {
          navigate('/confirmation');
        },
      }
    );

  return isActive ? (
    <Stack direction="row">
      <StepRuler icon={CheckShield} />
      <Stack w="full" spacing={4}>
        <Heading fontSize="xl" color="brand.secondary.swatch4">
          Verify & Send Donation
        </Heading>
        <List spacing={4}>
          <ListItem>
            <Text align="left" fontSize="md" color="brand.additional.black">
              Donor’s First Name
            </Text>
            <Text
              align="left"
              fontSize="md"
              fontWeight="bold"
              color="brand.additional.black"
            >
              {formData?.donorFirstName}
            </Text>
          </ListItem>
          <ListItem>
            <Text align="left" fontSize="md" color="brand.additional.black">
              Donor’s Last Name
            </Text>
            <Text
              align="left"
              fontSize="md"
              fontWeight="bold"
              color="brand.additional.black"
            >
              {formData?.donorLastName}
            </Text>
          </ListItem>
          <ListItem>
            <Text align="left" fontSize="md" color="brand.additional.black">
              Donation Amount
            </Text>
            <Text
              align="left"
              fontSize="md"
              fontWeight="bold"
              color="brand.additional.black"
            >
              ${formData.giftAmount}
            </Text>
          </ListItem>
          <ListItem>
            <HStack>
              <Image
                w="120px"
                h="68px"
                alt={`checkFront - ${formData?.donorLastName}`}
                src={formData?.checkFrontImage?.imageData}
              />
              <Image
                w="120px"
                h="68px"
                alt={`checkBack - ${formData?.donorLastName}`}
                src={formData?.checkBackImage?.imageData}
              />
            </HStack>
          </ListItem>
        </List>
        <Button
          colorScheme="blue"
          onClick={handleSendDonations}
          isLoading={sendDonations.isLoading}
        >
          Send donation
        </Button>
      </Stack>
    </Stack>
  ) : (
    <Button
      p={0}
      colorScheme="blue"
      variant="ghost"
      onClick={handleReview}
      textDecoration={hasStep ? 'underline' : 'none'}
      leftIcon={<CheckShield boxSize={6} />}
    >
      Verify & Send Donation
    </Button>
  );
};
